import React from 'react';
import { Redirect } from 'react-router-dom';
import Yorum from 'src/views/Chat';
import DashboardView from 'src/views/Dashboard';
import Error404 from 'src/views/Error404';
import Login from 'src/views/Login';
import OverView from 'src/views/Overview';
import MaterialOrder from 'src/views/MaterialOrder';
import Profil from 'src/views/Profile';
import Isler from 'src/views/WorkOrder';
import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';
import BultenlerView from './views/Bulletin';
import DosyaView from './views/File';
import YardimView from './views/Help';
import MalzemeIhtiyacView from './views/MaterialRequirement';
import ProdcutDetailControlView from './views/ProductDetailControl';
import ServisIletisimView from './views/ServiceContact';
import TodaySummaryView from './views/TodaySummary';
import UyariMerkeziView from './views/WarningCenter';
import TeknikYonetimView from './views/TechnicianManagement';
import ServiceShopMaterialView from './views/ServiceShopMaterial';
import ServiceOffWorkView from 'src/views/ServiceOffWork';
import Dashboard from './views/Dashboard/dashboard';
import TechnicalKnowledgeBase from './views/TechnicalKnowledgeBase';
import UnauthorizedView from 'src/views/Unauthorized';
import ProductReleaseView from 'src/views/ProductRelease';
import CustomerFeedbackView from 'src/views/CustomerFeedback'
import ServicePartnerContactView from 'src/views/ServicePartnerContact'
import WatchListView from './views/WatchList';
import ForConsumer from 'src/views/MaterialOrder2/Create/ForConsumer';
import ForPartner from './views/MaterialOrder2/Create/ForPartner';
import ForOTC from './views/MaterialOrder2/Create/ForOTC';
import Query from './views/MaterialOrder2/Query';
import ExternalSystemTasks from './views/ExternalSystemTasks';
import MyEmailWork from './components/MailOrbit/MyEmailWork';
import StandaloneConversation from './components/MailOrbit/StandaloneConversation';
import SurveyModule from './views/SurveyModule';
import WorkOrderCargo from './views/WorkOrderCargo';
import RevenueGenerationView from 'src/views/RevenueGeneration'
import ConsentPage from 'src/components/ConsentPage';
import SironexPayments from './views/SironexPayments';
import Sales from 'src/views/Sales';
import ProductSales from 'src/views/Sales/ProductSales/ProductSales';
import ExtraWarrantySales from 'src/views/Sales/ExtraWarrantySales';
import MaterialSales from 'src/views/Sales/MaterialSales';
import WorkOrderUrgentCustomers from './views/WorkOrderUrgentCustomers';
import OutboundCallActivitiesList from './views/OutboundCallActivitiesList';
import AreaSearch from './views/AreaSearch';



export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: Login
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/consent-page',
    exact: true,
    component: ConsentPage
  },
  {
    path: '/Unauthorized',
    component: ErrorLayout,
    routes: [
      {
        path: '/Unauthorized',
        exact: true,
        component: UnauthorizedView
      },
      {
        component: () => <Redirect to="/Unauthorized" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/Dashboard/dashboard',
        exact: true,
        component: Dashboard
      },
      {
        path: '/chat',
        exact: true,
        component: Yorum
      },
      {
        path: '/chat/:id',
        exact: true,
        component: Yorum
      },
      {
        path: '/dashboards/default',
        exact: true,
        component: TodaySummaryView
      },
      {
        path: '/WorkOrder/:id/:tab',
        exact: true,
        component: Isler
      },
      {
        path: '/overview',
        exact: true,
        component: OverView
      },
      {
        path: '/materialOrder',
        exact: true,
        component: MaterialOrder
      },
      {
        path: '/Dashboard',
        exact: true,
        component: DashboardView
      },

      {
        path: '/Bultenler',
        exact: true,
        component: BultenlerView
      },
      {
        path: '/Dosya',
        exact: true,
        component: DosyaView
      },
      {
        path: '/WatchList',
        exact: true,
        component: WatchListView
      },
      {
        path: '/ProductDetailControl',
        exact: true,
        component: ProdcutDetailControlView
      },
      {
        path: '/MalzemeIhtiyac',
        exact: true,
        component: MalzemeIhtiyacView
      },
      {
        path: '/UyariMerkezi',
        exact: true,
        component: UyariMerkeziView
      },
      {
        path: '/TechnicianManagement',
        exact: true,
        component: TeknikYonetimView
      },
      {
        path: '/TechnicalKnowledgeBase',
        exact: true,
        component: TechnicalKnowledgeBase
      },
      {
        path: '/ServiceShopMaterial',
        exact: true,
        component: ServiceShopMaterialView
      },
      {
        path: '/ProductRelease',
        exact: true,
        component: ProductReleaseView
      },
      {
        path: '/ServisIletisim',
        exact: true,
        component: ServisIletisimView
      },
      {
        path: '/ServiceOffWork',
        exact: true,
        component: ServiceOffWorkView
      },
      {
        path: '/Yardim',
        exact: true,
        component: YardimView
      },
      {
        path: '/CustomerFeedback',
        exact: true,
        component: CustomerFeedbackView
      },
      {
        path: '/RevenueGeneration',
        exact: true,
        component: RevenueGenerationView
      },
      {
        path: '/ServicePartnerContact',
        exact: true,
        component: ServicePartnerContactView
      },
      {
        path: '/profile/:id',
        exact: true,
        component: Profil
      },
      {
        path: '/profile/:id/:tab',
        exact: true,
        component: Profil
      },
      {
        path: '/materialOrder2/Query',
        exact: true,
        component: Query
      },
      {
        path: '/materialOrder2/Create/ForConsumer/:ConsumerId?/:WorkOrderId?/:ProductSKU?',
        exact: true,
        component: ForConsumer
      },
      {
        path: '/materialOrder2/Create/ForPartner',
        exact: true,
        component: ForPartner
      },
      {
        path: '/materialOrder2/Create/ForOTC',
        exact: true,
        component: ForOTC
      },
      {
        path: '/externalsystemtasks',
        exact: true,
        component: ExternalSystemTasks
      },
      {
        path: '/myemailwork',
        exact: true,
        component: MyEmailWork
      },
      {
        path: '/MailOrbitConversation/:conversationId',
        exact: true,
        component: StandaloneConversation
      },
      {
        path: '/WorkOrderUrgentCustomers',
        exact: true,
        component: WorkOrderUrgentCustomers
      },
      {
        path: '/surveymodule',
        exact: true,
        component: SurveyModule
      },
      {
        path: '/WorkOrderCargo',
        exact: true,
        component: WorkOrderCargo
      },
      {
        path: '/SironexPayments',
        exact: true,
        component: SironexPayments
      },
      {
        path: '/Sales/Product',
        exact: true,
        component: ProductSales
      },
      {
        path: '/Sales/ExtraWarranty',
        exact: true,
        component: ExtraWarrantySales
      },
      {
        path: '/Sales/Material',
        exact: true,
        component: MaterialSales
      },
      {
        path: '/Sales',
        exact: true,
        component: Sales
      },
      {
        path: '/OutboundCallActivitiesList',
        exact: true,
        component: OutboundCallActivitiesList
      },
      {
        path: '/AreaSearch',
        exact: true,
        component: AreaSearch
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
